/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_ThinkingInputs */

const en_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const th_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังพิมพ์…`)
};

const ja_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const fr_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const es_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const ru_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const zh_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typing…`)
};

const vi_chat_thinking = /** @type {(inputs: Chat_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang trả lời…`)
};

/**
* | output |
* | --- |
* | "Typing…" |
*
* @param {Chat_ThinkingInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_thinking = /** @type {((inputs?: Chat_ThinkingInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_ThinkingInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_thinking(inputs)
	if (locale === "ja") return ja_chat_thinking(inputs)
	if (locale === "fr") return fr_chat_thinking(inputs)
	if (locale === "es") return es_chat_thinking(inputs)
	if (locale === "ru") return ru_chat_thinking(inputs)
	if (locale === "zh") return zh_chat_thinking(inputs)
	if (locale === "vi") return vi_chat_thinking(inputs)
	return en_chat_thinking(inputs)
});